import { Order, Loan, Application, Account, Collateral, CollateralMng, Reporting, Print } from 'WebAPI'

export const PRINT_URL = 'http://localhost:8889'

export const REDUCER_NAME = 'LKPrintButton'
export const FETCHER_NAME = 'LKPrintButton'

export const actions = {
  OPEN_MENU: 'LKPrintButton/OPEN_MENU',
  CLOSE_MENU: 'LKPrintButton/CLOSE_MENU',
}

export const types = {
  loan: 'loan',
  loanCollateral: 'loanCollateral',
  client: 'client',
  application: 'application',
  collateral: 'collateral',
  account: 'account',
  entry: 'entry',
  entryConvert: 'entryConvert',
  loanCalculator: 'loancalculator',
  collateralMng: 'collateralmng',
  reporting: 'reporting',
  sdacra: 'sdacra',
}

export const apis = {
  [types.application]: Application.print,
  [types.loan]: Loan.print,
  [types.loanCollateral]: Loan.print,
  [types.client]: Print.printClient,
  [types.entry]: Order.print,
  [types.entryConvert]: Order.print,
  [types.loanCalculator]: Print.printLoanCalculator,
  [types.collateralMng]: CollateralMng.print,
  [types.account]: Account.print,
  [types.reporting]: Reporting.print,
  [types.sdacra]: Print.printCRA,
  [types.collateral]: Collateral.print,
}

export const hashNames = {
  [types.application]: 'HashSum_PrintReportIDAppID_',
  [types.loan]: 'HashSum_PrintReportIDLoanID_',
  [types.loanCollateral]: 'HashSum_PrintReportIDLoanIDCollateralID_',
  [types.client]: 'HashSum_PrintReportIDClientID_',
  [types.entry]: 'HashSum_PrintReportIDEntryID_',
  [types.entryConvert]: 'HashSum_PrintReportIDOID_',
  [types.loanCalculator]: 'HashSum_PrintReportIDDemoScheduleSequenceID_',
  [types.collateralMng]: 'HashSum_PrintReportIDCMSessionID_',
  [types.account]: 'HashSum_PrintReportIDAccountID_',
  [types.reporting]: 'HashSum_PrintReportIDReportID_',
  [types.sdacra]: 'HashSum_PrintReportID_',
  [types.collateral]: 'HashSum_PrintReportIDCollateralID_',
}
